module.exports = __webpack_public_path__ + "img/licenseSelect.670bcaff.png";